export default __webpack_public_path__ + "static/media/games.9ffa7880.png";